export default function ResumeContent() {
    return(
        <iframe src="../laptopAssets/resume/Jeffreys_Resume-forWeb.pdf" title="Jeffreys Professional Resume" width="100%" height="100%" />
    )
}